import { render, staticRenderFns } from "./important_message_bar.vue?vue&type=template&id=b1103c92&"
import script from "./important_message_bar.vue?vue&type=script&lang=js&"
export * from "./important_message_bar.vue?vue&type=script&lang=js&"
import style0 from "./important_message_bar.vue?vue&type=style&index=0&id=b1103c92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports